module.exports = __webpack_public_path__ + "media/images/ln/num_8-4f6a8b2bd42c08dc72684fb11a5c5b06.png";